const TOKEN_KEY = 'token';
const SESSION_KEY = 'sessionId';

export function setToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export function setSessionId(sessionId: string) {
  localStorage.setItem(SESSION_KEY, sessionId);
}

export function getSessionId(): string | null {
  return localStorage.getItem(SESSION_KEY);
}

export function removeSessionId() {
  localStorage.removeItem(SESSION_KEY);
}